import React from 'react';
import styled, { css } from 'styled-components';

import { Row, Col } from 'components/bootstrap';
import { DocumentTitle, PageHeader, IfPermitted } from 'components/common';
import CollectionsList from 'collections/components/CollectionsList';
import CreateCollectionButton from 'collections/components/CreateCollectionButton';
import HelpPopoverButton from 'components/common/HelpPopoverButton';

const StyledBulletList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.md};
    margin-bottom: ${theme.spacings.xs};
    margin-left: ${theme.spacings.xs};
  `,
);

const StyledInfoList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
    margin-bottom: ${theme.spacings.xs};
    margin-left: ${theme.spacings.xs};
    list-style-type: none;
  `,
);

const StyledHeader = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacings.xs};
  `,
);

const CollectionsPage = () => (
  <DocumentTitle title="Collections">
    <PageHeader
      title={
        <StyledHeader>
          <span>Collections</span>
          <HelpPopoverButton
            bsSize="small"
            helpText={
              <StyledBulletList>
                <li>Sharing Collection Content with a user grants them permission to the sharable entities within.</li>
                <li>
                  Removing the sharing of a Collection from a user also retracts any permissions granted by the
                  Collection to that user.
                </li>
                <li>
                  A sharable entity such as a stream, dashboard or event may be added to a Collection as an action on
                  that entity on the corresponding page (with the given examples, on the pages Streams, Dashboards,
                  Alerts &gt; Event Definitions).
                </li>
                <li>
                  To modify the contents of a Collection, and the level of access the Collection grants, a user must be
                  granted permission to Manage that Collection.
                </li>

                <li>Only Administrators may add shared entities they do not own to Collections.</li>

                <li>
                  A team may have one or more Collections set as a Default Collection. Where this is set, any sharable
                  entity that user creates is automatically added to those Collections.
                </li>

                <li>
                  Use Collections to ease permission management of sharable entities that have a specific grouping, such
                  as a department, region, or business unit.
                </li>
              </StyledBulletList>
            }
          />
        </StyledHeader>
      }
      topActions={
        <IfPermitted permissions="collections:create">
          <CreateCollectionButton bsStyle="primary" buttonText="Create" />
        </IfPermitted>
      }>
      <StyledInfoList>
        <li>Collections are a tool to assist the management of content sharing.</li>
        <li>A Collection is a grouping of sharable entities, such as streams, dashboards and events.</li>
        <li>
          The content of a Collection can be quickly shared with a User or Team to grant permissions to sharable
          entities in bulk.
        </li>
      </StyledInfoList>
    </PageHeader>
    <Row className="content">
      <Col md={12}>
        <CollectionsList />
      </Col>
    </Row>
  </DocumentTitle>
);

export default CollectionsPage;
